import { createRouter, createWebHistory } from "vue-router";
import authGuard from "@/middleware/authGuard"; // Importa o middleware

import LoginPage from "@/views/LoginPage.vue";
import MainView from "@/views/MainView.vue";
import DashboardPage from "@/components/Dashboard/DashboardPage.vue";
import EmpresaConfig from "@/components/Configuracoes/EmpresaConfig.vue";

import ForgotPassword from "@/views/ForgotPassword.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import CobrancasPublicas from "@/views/CobrancasPublicas.vue";





// Rotas de Gestão

// import ListarRelatorios from "@/components/Gestao/Relatorios/ListarRelatorios.vue";

import ReportPrintWrapper        from '@/components/Gestao/Relatorios/ReportPrintWrapper.vue'
import RelatoriosView            from '@/components/Gestao/Relatorios/RelatoriosView.vue'
import AlunosAniversariantes     from '@/components/Gestao/Relatorios/Cadastrais/AlunosAniversariantes.vue'
import AlunosAtivos              from '@/components/Gestao/Relatorios/Cadastrais/AlunosAtivos.vue'
import PorPeriodo                from '@/components/Gestao/Relatorios/Despesas/PorPeriodo.vue'
import APagar                    from '@/components/Gestao/Relatorios/Despesas/APagar.vue'
import PagasPorPagamento         from '@/components/Gestao/Relatorios/Despesas/PagasPorPagamento.vue'
import PagasPorVencimento        from '@/components/Gestao/Relatorios/Despesas/PagasPorVencimento.vue'
import AnalisePorRefil           from '@/components/Gestao/Relatorios/Despesas/AnalisePorRefil.vue'
import FechamentoDiario          from '@/components/Gestao/Relatorios/Financeiros/FechamentoDiario.vue'


// Rotas de Gráficos

import Financeiros               from '@/components/Gestao/Graficos/Financeiros/Financeiros.vue'
import Operacionais               from '@/components/Gestao/Graficos/Operacionais/Operacionais.vue'
import Comerciais               from '@/components/Gestao/Graficos/Comerciais/Comerciais.vue'


// Rotas de Cadastro

import ListarPessoasFisicas from "@/components/Cadastros/PessoasFisicas/ListarPessoasFisicas.vue";
import FormularioPessoaFisica from "@/components/Cadastros/PessoasFisicas/FormularioPessoaFisica.vue";
import DetalharPessoaFisica from "@/components/Cadastros/PessoasFisicas/DetalharPessoaFisica.vue";

import ListarPessoasJuridicas from "@/components/Cadastros/PessoasJuridicas/ListarPessoasJuridicas.vue";
import FormularioPessoaJuridica from "@/components/Cadastros/PessoasJuridicas/FormularioPessoaJuridica.vue";
import DetalharPessoaJuridica from "@/components/Cadastros/PessoasJuridicas/DetalharPessoaJuridica.vue";

import ListarAnimais from "@/components/Cadastros/Animais/ListarAnimais.vue";
import FormularioAnimal from "@/components/Cadastros/Animais/FormularioAnimal.vue";
import DetalharAnimal from "@/components/Cadastros/Animais/DetalharAnimal.vue";

import ListarBrindes from "@/components/Cadastros/Brindes/ListarBrindes.vue";
import FormularioBrinde from "@/components/Cadastros/Brindes/FormularioBrinde.vue";
import DetalharBrinde from "@/components/Cadastros/Brindes/DetalharBrinde.vue";

import ListarCategoriasPlanos from "@/components/Cadastros/CategoriasPlanos/ListarCategoriasPlanos.vue";
import FormularioCategoriaPlano from "@/components/Cadastros/CategoriasPlanos/FormularioCategoriaPlano.vue";
import DetalharCategoriaPlano from "@/components/Cadastros/CategoriasPlanos/DetalharCategoriaPlano.vue";

import ListarCategoriasProdutos      from "@/components/Cadastros/CategoriasProdutos/ListarCategoriasProdutos.vue";
import FormularioCategoriaProduto    from "@/components/Cadastros/CategoriasProdutos/FormularioCategoriaProduto.vue";
import DetalharCategoriaProduto      from "@/components/Cadastros/CategoriasProdutos/DetalharCategoriaProduto.vue";

import ListarConvenios from "@/components/Cadastros/Convenios/ListarConvenios.vue";
import FormularioConvenio from "@/components/Cadastros/Convenios/FormularioConvenio.vue";
import DetalharConvenio from "@/components/Cadastros/Convenios/DetalharConvenio.vue";

import ListarNiveisTurmas from "@/components/Cadastros/NiveisTurmas/ListarNiveisTurmas.vue";
import FormularioNivelTurma from "@/components/Cadastros/NiveisTurmas/FormularioNivelTurma.vue";
import DetalharNivelTurma from "@/components/Cadastros/NiveisTurmas/DetalharNivelTurma.vue";

import ListarCargosFuncionarios from "@/components/Cadastros/CargosFuncionarios/ListarCargosFuncionarios.vue";
import FormularioCargoFuncionario from "@/components/Cadastros/CargosFuncionarios/FormularioCargoFuncionario.vue";
import DetalharCargoFuncionario from "@/components/Cadastros/CargosFuncionarios/DetalharCargoFuncionario.vue";

import ListarFuncionarios from "@/components/Cadastros/Funcionarios/ListarFuncionarios.vue";
import FormularioFuncionario from "@/components/Cadastros/Funcionarios/FormularioFuncionario.vue";
import DetalharFuncionario from "@/components/Cadastros/Funcionarios/DetalharFuncionario.vue";

import ListarTurmas from "@/components/Cadastros/Turmas/ListarTurmas.vue";
import FormularioTurma from "@/components/Cadastros/Turmas/FormularioTurma.vue";
import DetalharTurma from "@/components/Cadastros/Turmas/DetalharTurma.vue";

import ListarTiposPlanos from "@/components/Cadastros/TiposPlanos/ListarTiposPlanos.vue";
import FormularioTipoPlano from "@/components/Cadastros/TiposPlanos/FormularioTipoPlano.vue";
import DetalharTipoPlano from "@/components/Cadastros/TiposPlanos/DetalharTipoPlano.vue";

import ListarPlanosMatriculas from "@/components/Cadastros/PlanosMatriculas/ListarPlanosMatriculas.vue";
import FormularioPlanoMatricula from "@/components/Cadastros/PlanosMatriculas/FormularioPlanoMatricula.vue";
import DetalharPlanoMatricula from "@/components/Cadastros/PlanosMatriculas/DetalharPlanoMatricula.vue";

import ListarPeriodosAvaliacoes from "@/components/Cadastros/PeriodoAvaliacoes/ListarPeriodosAvaliacoes.vue";
import FormularioPeriodoAvaliacao from "@/components/Cadastros/PeriodoAvaliacoes/FormularioPeriodoAvaliacao.vue";
import DetalharPeriodoAvaliacao from "@/components/Cadastros/PeriodoAvaliacoes/DetalharPeriodoAvaliacao.vue";

import ListarProdutos       from "@/components/Cadastros/Produtos/ListarProdutos.vue";
import FormularioProduto    from "@/components/Cadastros/Produtos/FormularioProduto.vue";
import DetalharProduto      from "@/components/Cadastros/Produtos/DetalharProduto.vue";

import ListarDescontos       from "@/components/Cadastros/Descontos/ListarDescontos.vue";
import FormularioDesconto    from "@/components/Cadastros/Descontos/FormularioDesconto.vue";
import DetalharDesconto      from "@/components/Cadastros/Descontos/DetalharDesconto.vue";


// Rotas de Operacional

import ListarAniversariantes from "@/components/Operacional/Aniversariantes/ListarAniversariantes.vue";


import ListarSaidasAnimais from "@/components/Operacional/SaidasAnimais/ListarSaidasAnimais.vue";
import FormularioSaidaAnimal from "@/components/Operacional/SaidasAnimais/FormularioSaidaAnimal.vue";
import DetalharSaidaAnimal from "@/components/Operacional/SaidasAnimais/DetalharSaidaAnimal.vue";

import ListarProspeccao from "@/components/Operacional/Prospeccao/ListarProspeccao.vue";
import FormularioProspeccao from "@/components/Operacional/Prospeccao/FormularioProspeccao.vue";
import DetalharProspeccao from "@/components/Operacional/Prospeccao/DetalharProspeccao.vue";

import ListarAulasAvulsas from "@/components/Operacional/AulasAvulsas/ListarAulasAvulsas.vue";
import FormularioAulaAvulsa from "@/components/Operacional/AulasAvulsas/FormularioAulaAvulsa.vue";
import DetalharAulaAvulsa from "@/components/Operacional/AulasAvulsas/DetalharAulaAvulsa.vue";
import ImprimirReciboAulasAvulsas from "@/components/Operacional/AulasAvulsas/ImprimirRecibo.vue";

import ListarMatriculas from "@/components/Operacional/Matriculas/ListarMatriculas.vue";
import FormularioMatricula from "@/components/Operacional/Matriculas/FormularioMatricula.vue";
import DetalharMatricula from "@/components/Operacional/Matriculas/DetalharMatricula.vue";
import ImprimirReciboMatricula from "@/components/Operacional/Matriculas/ImprimirReciboMatricula.vue";


import ModalRenovarMatricula from "@/components/modals/RenovarMatricula.vue";

import ListarPosvendas from "@/components/Operacional/Posvendas/ListarPosvendas.vue";
// import FormularioPosvenda from "@/components/Operacional/Posvendas/FormularioPosvenda.vue";
import DetalharPosvenda from "@/components/Operacional/Posvendas/DetalharPosvenda.vue";

import ListarAulasReposicao from "@/components/Operacional/AulasReposicao/ListarAulasReposicao.vue";
import FormularioAulaReposicao from "@/components/Operacional/AulasReposicao/FormularioAulaReposicao.vue";
import DetalharAulaReposicao from "@/components/Operacional/AulasReposicao/DetalharAulaReposicao.vue";

import ListarTurmasInstrutor from "@/components/Operacional/TurmasInstrutor/ListarTurmasInstrutor.vue";
// import FormularioTurmaInstrutor from "@/components/Operacional/TurmasInstrutor/FormularioTurmaInstrutor.vue";
// import DetalharTurmaInstrutor from "@/components/Operacional/TurmasInstrutor/DetalharTurmaModal.vue";
import DetalharTurmaInstrutor from "@/components/Operacional/TurmasInstrutor/DetalharTurmaInstrutor.vue";

import ListarAvaliacoesDesempenho from "@/components/Operacional/AvaliacoesDesempenho/ListarAvaliacoesDesempenho.vue";
// import FormularioAvaliacaoDesempenho from "@/components/Operacional/AvaliacoesDesempenho/FormularioAvaliacaoDesempenho.vue";
// import DetalharAvaliacaoDesempenho from "@/components/Operacional/AvaliacoesDesempenho/DetalharAvaliacaoDesempenho.vue";

import ListarEmarketingRespativos from "@/components/Operacional/Emarketing/ListarEmarketingRespativos.vue";
import ListarEmarketingRespinativos from "@/components/Operacional/Emarketing/ListarEmarketingRespinativos.vue";

import ListarSupervisoes from "@/components/Operacional/Supervisoes/ListarSupervisoes.vue";
import ListarProtocolosQueda from "@/components/Operacional/ProtocolosQueda/ListarProtocolosQueda.vue";


// Rotas de Loja
import ListarVendas from "@/components/Loja/Vendas/ListarVendas.vue";
import FormularioVenda from "@/components/Loja/Vendas/FormularioVenda.vue";
import DetalharVenda from "@/components/Loja/Vendas/DetalharVenda.vue";
import ReciboVenda   from "@/components/Loja/Vendas/ReciboVenda.vue";

import ListarEntradas    from "@/components/Loja/Entradas/ListarEntradas.vue";
import FormularioEntrada from "@/components/Loja/Entradas/FormularioEntrada.vue";
import DetalharEntrada   from "@/components/Loja/Entradas/DetalharEntrada.vue";




// Rotas de Financeiro

import ListarValores from "@/components/Financeiro/Valores/ListarValores.vue";
import FormularioValor from "@/components/Financeiro/Valores/FormularioValor.vue";
import DetalharValor from "@/components/Financeiro/Valores/DetalharValor.vue";

import ListarPlanosContas from "@/components/Financeiro/PlanosContas/ListarPlanosContas.vue";
import FormularioPlanoConta from "@/components/Financeiro/PlanosContas/FormularioPlanoConta.vue";
import DetalharPlanoConta from "@/components/Financeiro/PlanosContas/DetalharPlanoConta.vue";

import ListarSubcontas from "@/components/Financeiro/Subcontas/ListarSubcontas.vue";
import FormularioSubconta from "@/components/Financeiro/Subcontas/FormularioSubconta.vue";
import DetalharSubconta from "@/components/Financeiro/Subcontas/DetalharSubconta.vue";

import ListarOperadoresPagamentos from "@/components/Financeiro/Parametros/Operadores/ListarOperadoresPagamentos.vue";
import FormularioOperadorPagamento from "@/components/Financeiro/Parametros/Operadores/FormularioOperadorPagamento.vue";
import DetalharOperadorPagamento from "@/components/Financeiro/Parametros/Operadores/DetalharOperadorPagamento.vue";

import ListarMeiosPagamentos from "@/components/Financeiro/Parametros/Meios/ListarMeiosPagamentos.vue";
import FormularioMeioPagamento from "@/components/Financeiro/Parametros/Meios/FormularioMeioPagamento.vue";
import DetalharMeioPagamento from "@/components/Financeiro/Parametros/Meios/DetalharMeioPagamento.vue";

import ListarFormasPagamentos from "@/components/Financeiro/Parametros/Formas/ListarFormasPagamentos.vue";
import FormularioFormaPagamento from "@/components/Financeiro/Parametros/Formas/FormularioFormaPagamento.vue";
import DetalharFormaPagamento from "@/components/Financeiro/Parametros/Formas/DetalharFormaPagamento.vue";

import ListarBandeirasPagamentos from "@/components/Financeiro/Parametros/Bandeiras/ListarBandeirasPagamentos.vue";
import FormularioBandeiraPagamento from "@/components/Financeiro/Parametros/Bandeiras/FormularioBandeiraPagamento.vue";
import DetalharBandeiraPagamento from "@/components/Financeiro/Parametros/Bandeiras/DetalharBandeiraPagamento.vue";

import ListarTiposPagamentos from "@/components/Financeiro/Parametros/Tipos/ListarTiposPagamentos.vue";
import FormularioTipoPagamento from "@/components/Financeiro/Parametros/Tipos/FormularioTipoPagamento.vue";
import DetalharTipoPagamento from "@/components/Financeiro/Parametros/Tipos/DetalharTipoPagamento.vue";

import ListarTaxasPagamentos from "@/components/Financeiro/Parametros/Taxas/ListarTaxasPagamentos.vue";
import FormularioTaxaPagamento from "@/components/Financeiro/Parametros/Taxas/FormularioTaxaPagamento.vue";
import DetalharTaxaPagamento from "@/components/Financeiro/Parametros/Taxas/DetalharTaxaPagamento.vue";

import ListarContasFinanceiras from "@/components/Financeiro/ContasFinanceiras/ListarContasFinanceiras.vue";
import FormularioContaFinanceira from "@/components/Financeiro/ContasFinanceiras/FormularioContaFinanceira.vue";
import DetalharContaFinanceira from "@/components/Financeiro/ContasFinanceiras/DetalharContaFinanceira.vue";

import ListarRegistrosFinanceiros from "@/components/Financeiro/RegistrosFinanceiros/ListarRegistrosFinanceiros.vue";
import FormularioRegistroFinanceiro from "@/components/Financeiro/RegistrosFinanceiros/FormularioRegistroFinanceiro.vue";
import DetalharRegistroFinanceiro from "@/components/Financeiro/RegistrosFinanceiros/DetalharRegistroFinanceiro.vue";

import ListarReceitasPlanos from "@/components/Financeiro/Receitas/ListarReceitasPlanos.vue";
// import FormularioReceitaPlano from "@/components/Financeiro/Receitas/FormularioReceitaPlano.vue";
import DetalharReceitaPlano from "@/components/Financeiro/Receitas/DetalharReceitaPlano.vue";

import ListarReceitasGerais from "@/components/Financeiro/Receitas/ListarReceitasGerais.vue";
import FormularioReceitaGeral from "@/components/Financeiro/Receitas/FormularioReceitaGeral.vue";
import DetalharReceitaGeral from "@/components/Financeiro/Receitas/DetalharReceitaGeral.vue";

import ListarDespesas from "@/components/Financeiro/Despesas/ListarDespesas.vue";
import FormularioDespesa from "@/components/Financeiro/Despesas/FormularioDespesa.vue";
import DetalharDespesa from "@/components/Financeiro/Despesas/DetalharDespesa.vue";

import ListarTransferenciasContas from "@/components/Financeiro/TransferenciasContas/ListarTransferenciasContas.vue";
import FormularioTransferenciaConta from "@/components/Financeiro/TransferenciasContas/FormularioTransferenciaConta.vue";
import DetalharTransferenciaConta from "@/components/Financeiro/TransferenciasContas/DetalharTransferenciaConta.vue";

import ConciliacaoBancariaPage from "@/views/financeiro/ConciliacaoBancariaPage.vue";

import CobrancasEBoletos from "@/components/Financeiro/Cobrancas/CobrancasEBoletos.vue";
import ListarConfiguracoesCobrancas from "@/components/Financeiro/Cobrancas/Configuracoes/ListarConfiguracoesCobrancas.vue";
import FormularioConfiguracaoCobranca from "@/components/Financeiro/Cobrancas/Configuracoes/FormularioConfiguracaoCobranca.vue";
import DetalharCobranca from "@/components/Financeiro/Cobrancas/DetalharCobranca.vue";
import ListarPoliticasCobrancas from "@/components/Financeiro/Cobrancas/Politicas/ListarPoliticasCobrancas.vue";
import DetalharPoliticaCobranca from "@/components/Financeiro/Cobrancas/Politicas/DetalharPoliticaCobranca.vue";
import FormularioPoliticaCobranca from "@/components/Financeiro/Cobrancas/Politicas/FormularioPoliticaCobranca.vue";


// Rotas de Configuração

import ListarPerfisUsuarios from "@/components/Configuracoes/PerfisUsuarios/ListarPerfisUsuarios.vue";
import FormularioPerfilUsuario from "@/components/Configuracoes/PerfisUsuarios/FormularioPerfilUsuario.vue";
import DetalharPerfilUsuario from "@/components/Configuracoes/PerfisUsuarios/DetalharPerfilUsuario.vue";

import ListarUsuarios from "@/components/Configuracoes/Usuarios/ListarUsuarios.vue";
import FormularioUsuario from "@/components/Configuracoes/Usuarios/FormularioUsuario.vue";
import DetalharUsuario from "@/components/Configuracoes/Usuarios/DetalharUsuario.vue";

import SelecionarPessoaFisica from "@/components/Configuracoes/Usuarios/SelecionarPessoaFisica.vue";

import ListarDocumentos from "@/components/Configuracoes/Documentos/ListarDocumentos.vue";
import FormularioDocumento from "@/components/Configuracoes/Documentos/FormularioDocumento.vue";
import DetalharDocumento from "@/components/Configuracoes/Documentos/DetalharDocumento.vue";

import ListarCategoriasAvaliacoes from "@/components/Configuracoes/Avaliacoes/Categorias/ListarCategoriasAvaliacoes.vue";
import FormularioCategoriaAvaliacao from "@/components/Configuracoes/Avaliacoes/Categorias/FormularioCategoriaAvaliacao.vue";
import DetalharCategoriaAvaliacao from "@/components/Configuracoes/Avaliacoes/Categorias/DetalharCategoriaAvaliacao.vue";

import ListarBlocosAvaliacoes from "@/components/Configuracoes/Avaliacoes/Blocos/ListarBlocosAvaliacoes.vue";
import FormularioBlocoAvaliacao from "@/components/Configuracoes/Avaliacoes/Blocos/FormularioBlocoAvaliacao.vue";
import DetalharBlocoAvaliacao from "@/components/Configuracoes/Avaliacoes/Blocos/DetalharBlocoAvaliacao.vue";

import ListarQuestoesAvaliacoes from "@/components/Configuracoes/Avaliacoes/Questoes/ListarQuestoesAvaliacoes.vue";
import FormularioQuestaoAvaliacao from "@/components/Configuracoes/Avaliacoes/Questoes/FormularioQuestaoAvaliacao.vue";
import DetalharQuestaoAvaliacao from "@/components/Configuracoes/Avaliacoes/Questoes/DetalharQuestaoAvaliacao.vue";

import ListarOpcoesAvaliacoes from "@/components/Configuracoes/Avaliacoes/Opcoes/ListarOpcoesAvaliacoes.vue";
import FormularioOpcaoAvaliacao from "@/components/Configuracoes/Avaliacoes/Opcoes/FormularioOpcaoAvaliacao.vue";
import DetalharOpcaoAvaliacao from "@/components/Configuracoes/Avaliacoes/Opcoes/DetalharOpcaoAvaliacao.vue";

import ListarFormulariosAvaliacoes from "@/components/Configuracoes/Formularios/ListarFormulariosAvaliacoes.vue";
import FormularioFormularioAvaliacao from "@/components/Configuracoes/Formularios/FormularioFormularioAvaliacao.vue";
import DetalharFormularioAvaliacao from "@/components/Configuracoes/Formularios/DetalharFormularioAvaliacao.vue";

import ListarRecessos from "@/components/Configuracoes/Recessos/ListarRecessos.vue";
import FormularioRecesso from "@/components/Configuracoes/Recessos/FormularioRecesso.vue";
import DetalharRecesso from "@/components/Configuracoes/Recessos/DetalharRecesso.vue";



// Rotas de Ajuda

import ListarMateriais from "@/components/Ajuda/Materiais/ListarMateriais.vue";
import FormularioMaterial from "@/components/Ajuda/Materiais/FormularioMaterial.vue";
// import DetalharMaterial from "@/components/Ajuda/Materiais/DetalharMaterial.vue";

import ListarVideoaulas from "@/components/Ajuda/Videoaulas/ListarVideoaulas.vue";
import FormularioVideoaula from "@/components/Ajuda/Videoaulas/FormularioVideoaula.vue";
// import DetalharVideoaula from "@/components/Ajuda/Videoaulas/DetalharVideoaula.vue";

import ExibirQuiz from "@/components/Ajuda/Quiz/HipicaQuiz.vue";

import ExibirCavalinho from "@/components/Ajuda/Jogos/CavaloSaltador.vue";

import ExibirMontador from "@/components/Ajuda/Montador/MontadorPistaHipismo.vue";

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },

  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },

  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
  },

  {
    path: '/cobrancas/:token',
    alias: '/public/cobrancas/lotes/:token',
    name: 'CobrancasPublicas',
    component: CobrancasPublicas,
    meta: { public: true },
  },

  {
    path: '/minha-conta/senha',
    name: 'MinhaContaSenha',
    component: () => import('@/views/MinhaContaSenha.vue'),
    meta: { requiresAuth: true },
  },

  {
    path: '/',
    component: MainView,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        redirect: 'dashboard'  // Rota padrão que redireciona para /dashboard
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: DashboardPage,
      },
      {
        path: 'configuracoes/empresa',
        name: 'EmpresaConfig',
        component: EmpresaConfig,
      },



      // Rotas de Gestão

      // Rotas de Gráficos

      { path: "gestao/graficos/financeiros", name: "Financeiros", component: Financeiros },
      {
        path: "gestao/graficos/operacionais",
        name: "Operacionais",
        component: Operacionais,
        meta: { feature: "GRAFICO_PROSPECCAO_MATRICULAS" }
      },
      { path: "gestao/graficos/comerciais", name: "Comerciais", component: Comerciais },




      // Rotas de Relatórios

      {
        path: 'gestao/relatorios', component: RelatoriosView, children: [
          { path: 'cadastrais/aniversariantes', component: AlunosAniversariantes },
          { path: 'cadastrais/ativos',         component: AlunosAtivos },
          { path: 'despesas/periodo',           component: PorPeriodo },
          { path: 'despesas/a-pagar',           component: APagar },
          { path: 'despesas/pagas-pagamento',   component: PagasPorPagamento },
          { path: 'despesas/pagas-vencimento',  component: PagasPorVencimento },
          { path: 'despesas/analise-refil',     component: AnalisePorRefil },
        ]
      },
      {
        // Rota genérica de “impressão” (recebe reportKey + parâmetros via query)
        path: 'gestao/relatorios/print/:reportKey',
        component: ReportPrintWrapper,
        props: route => ({
          title:      route.query.title || '',
          reportKey:  route.params.reportKey,
          params:     { ...route.query }, // inclui dataInicio, dataFim, subcontaId etc.
          subtitle:   route.query.subtitle   // adicionar aqui
        })
      },
      { path: 'gestao/relatorios/financeiros/fechamento-diario', component: FechamentoDiario },

      // Rotas de Cadastro

      // Rotas de Pessoas Físicas
      { path: "cadastros/pessoas-fisicas", name: "ListarPessoasFisicas", component: ListarPessoasFisicas },
      { path: "cadastros/pessoas-fisicas/novo", name: "CadastrarPessoaFisica", component: FormularioPessoaFisica },
      { path: "cadastros/pessoas-fisicas/:id", name: "EditarPessoaFisica", component: FormularioPessoaFisica, props: true },
      { path: '/cadastros/pessoas-fisicas/:id/detalhar', name: 'DetalharPessoaFisica', component: DetalharPessoaFisica, props: true },

      // Rotas de Pessoas Jurídicas
      { path: "cadastros/pessoas-juridicas", name: "ListarPessoasJuridicas", component: ListarPessoasJuridicas },
      { path: "cadastros/pessoas-juridicas/novo", name: "CadastrarPessoaJuridica", component: FormularioPessoaJuridica },
      { path: "cadastros/pessoas-juridicas/:id", name: "EditarPessoaJuridica", component: FormularioPessoaJuridica, props: true },
      { path: '/cadastros/pessoas-juridicas/:id/detalhar', name: 'DetalharPessoaJuridica', component: DetalharPessoaJuridica, props: true },

      // Rotas de Animais
      { path: "cadastros/animais", name: "ListarAnimais", component: ListarAnimais },
      { path: "cadastros/animais/novo", name: "CadastrarAnimal", component: FormularioAnimal },
      { path: "cadastros/animais/:id", name: "EditarAnimal", component: FormularioAnimal, props: true },
      { path: '/cadastros/animais/:id/detalhar', name: 'DetalharAnimal', component: DetalharAnimal, props: true },

      // Rotas de Brindes
      { path: "cadastros/brindes", name: "ListarBrindes", component: ListarBrindes },
      { path: "cadastros/brindes/novo", name: "CadastrarBrindes", component: FormularioBrinde },
      { path: "cadastros/brindes/:id", name: "EditarBrindes", component: FormularioBrinde, props: true },
      { path: '/cadastros/brindes/:id/detalhar', name: 'DetalharBrindes', component: DetalharBrinde, props: true },

      // Rotas de Categorias de Planos
      { path: "cadastros/categorias-de-planos", name: "ListarCategoriasPlanos", component: ListarCategoriasPlanos },
      { path: "cadastros/categorias-de-planos/novo", name: "CadastrarCategoriasPlanos", component: FormularioCategoriaPlano },
      { path: "cadastros/categorias-de-planos/:id", name: "EditarCategoriasPlanos", component: FormularioCategoriaPlano, props: true },
      { path: '/cadastros/categorias-de-planos/:id/detalhar', name: 'DetalharCategoriasPlanos', component: DetalharCategoriaPlano, props: true },

      // Rotas de Categorias de Produtos
      { path: "/cadastros/categorias-de-produtos", name: "ListarCategoriasProdutos", component: ListarCategoriasProdutos },
      { path: "/cadastros/categorias-de-produtos/novo", name: "CadastrarCategoriaProduto", component: FormularioCategoriaProduto },
      { path: "/cadastros/categorias-de-produtos/:id", name: "EditarCategoriaProduto", component: FormularioCategoriaProduto, props: true },
      { path: "/cadastros/categorias-de-produtos/:id/detalhar", name: "DetalharCategoriaProduto", component: DetalharCategoriaProduto, props: true },

      // Rotas de Convênios
      { path: "cadastros/convenios", name: "ListarConvenios", component: ListarConvenios },
      { path: "cadastros/convenios/novo", name: "CadastrarConvenios", component: FormularioConvenio },
      { path: "cadastros/convenios/:id", name: "EditarConvenios", component: FormularioConvenio, props: true },
      { path: '/cadastros/convenios/:id/detalhar', name: 'DetalharConvenios', component: DetalharConvenio, props: true },

      // Rotas de Níveis de Turmas
      { path: "cadastros/niveis-turmas", name: "ListarNiveisTurmas", component: ListarNiveisTurmas },
      { path: "cadastros/niveis-turmas/novo", name: "CadastrarNiveisTurmas", component: FormularioNivelTurma },
      { path: "cadastros/niveis-turmas/:id", name: "EditarNiveisTurmas", component: FormularioNivelTurma, props: true },
      { path: '/cadastros/niveis-turmas/:id/detalhar', name: 'DetalharNiveisTurmas', component: DetalharNivelTurma, props: true },

      // Rotas de Cargos de Funcionários
      { path: "cadastros/cargos-funcionarios", name: "ListarCargosFuncionarios", component: ListarCargosFuncionarios },
      { path: "cadastros/cargos-funcionarios/novo", name: "CadastrarCargosFuncionarios", component: FormularioCargoFuncionario },
      { path: "cadastros/cargos-funcionarios/:id", name: "EditarCargosFuncionarios", component: FormularioCargoFuncionario, props: true },
      { path: '/cadastros/cargos-funcionarios/:id/detalhar', name: 'DetalharCargosFuncionarios', component: DetalharCargoFuncionario, props: true },

      // Rotas de Funcionários
      { path: "cadastros/funcionarios", name: "ListarFuncionarios", component: ListarFuncionarios },
      { path: "cadastros/funcionarios/novo", name: "CadastrarFuncionarios", component: FormularioFuncionario },
      { path: "cadastros/funcionarios/:id", name: "EditarFuncionarios", component: FormularioFuncionario, props: true },
      { path: '/cadastros/funcionarios/:id/detalhar', name: 'DetalharFuncionarios', component: DetalharFuncionario, props: true },

      // Rotas de Turmas
      { path: "cadastros/turmas", name: "ListarTurmas", component: ListarTurmas },
      { path: "cadastros/turmas/novo", name: "CadastrarTurmas", component: FormularioTurma },
      { path: "cadastros/turmas/:id", name: "EditarTurmas", component: FormularioTurma, props: true },
      { path: '/cadastros/turmas/:id/detalhar', name: 'DetalharTurmas', component: DetalharTurma, props: true },

      // Rotas de Tipos de Planos
      { path: "cadastros/tipos-planos", name: "ListarTiposPlanos", component: ListarTiposPlanos },
      { path: "cadastros/tipos-planos/novo", name: "CadastrarTiposPlanos", component: FormularioTipoPlano },
      { path: "cadastros/tipos-planos/:id", name: "EditarTiposPlanos", component: FormularioTipoPlano, props: true },
      { path: '/cadastros/tipos-planos/:id/detalhar', name: 'DetalharTiposPlanos', component: DetalharTipoPlano, props: true },

      // Rotas de Planos de Matrículas
      { path: "cadastros/planos-matriculas", name: "ListarPlanosMatriculas", component: ListarPlanosMatriculas },
      { path: "cadastros/planos-matriculas/novo", name: "CadastrarPlanosMatriculas", component: FormularioPlanoMatricula },
      { path: "cadastros/planos-matriculas/:id", name: "EditarPlanosMatriculas", component: FormularioPlanoMatricula, props: true },
      { path: '/cadastros/planos-matriculas/:id/detalhar', name: 'DetalharPlanosMatriculas', component: DetalharPlanoMatricula, props: true },

      // Rotas de Períodos de Avaliações
      { path: "cadastros/avaliacoes-periodos", name: "ListarPeriodosAvaliacoes", component: ListarPeriodosAvaliacoes },
      { path: "cadastros/avaliacoes-periodos/novo", name: "CadastrarPeriodosAvaliacoes", component: FormularioPeriodoAvaliacao },
      { path: "cadastros/avaliacoes-periodos/:id", name: "EditarPeriodosAvaliacoes", component: FormularioPeriodoAvaliacao, props: true },
      { path: "/cadastros/avaliacoes-periodos/:id/detalhar", name: "DetalharPeriodosAvaliacoes", component: DetalharPeriodoAvaliacao, props: true },

      { path: "/cadastros/produtos", name: "ListarProdutos", component: ListarProdutos, meta: { feature: "LOJA" } },
      { path: "/cadastros/produtos/novo", name: "CadastrarProduto", component: FormularioProduto, meta: { feature: "LOJA" } },
      { path: "/cadastros/produtos/:id", name: "EditarProduto", component: FormularioProduto, props: true, meta: { feature: "LOJA" } },
      { path: "/cadastros/produtos/:id/detalhar", name: "DetalharProduto", component: DetalharProduto, props: true, meta: { feature: "LOJA" } },

      { path: "/cadastros/descontos", name: "ListarDescontos", component: ListarDescontos, },
      { path: "/cadastros/descontos/novo", name: "CadastrarDesconto", component: FormularioDesconto, },
      { path: "/cadastros/descontos/:id", name: "EditarDesconto", component: FormularioDesconto, props: true, },
      { path: "/cadastros/descontos/:id/detalhar", name: "DetalharDesconto", component: DetalharDesconto, props: true, },



      // Rotas de Operacional

      { path: "operacional/aniversariantes", name: "ListarAniversariantes", component: ListarAniversariantes },

      { path: "operacional/saidas-animais", name: "ListarSaidasAnimais", component: ListarSaidasAnimais },
      { path: "operacional/saidas-animais/novo", name: "CadastrarSaidasAnimais", component: FormularioSaidaAnimal },
      { path: "operacional/saidas-animais/:id", name: "EditarSaidasAnimais", component: FormularioSaidaAnimal, props: true },
      { path: '/operacional/saidas-animais/:id/detalhar', name: 'DetalharSaidasAnimais', component: DetalharSaidaAnimal, props: true },

      {
        path: "operacional/prospeccao",
        name: "ListarProspeccao",
        component: ListarProspeccao,
        meta: { feature: "PROSPECCAO" }
      },
      {
        path: "operacional/prospeccao/novo",
        name: "CadastrarProspeccao",
        component: FormularioProspeccao,
        meta: { feature: "PROSPECCAO" }
      },
      {
        path: "operacional/prospeccao/:id",
        name: "EditarProspeccao",
        component: FormularioProspeccao,
        props: true,
        meta: { feature: "PROSPECCAO" }
      },
      {
        path: '/operacional/prospeccao/:id/detalhar',
        name: 'DetalharProspeccao',
        component: DetalharProspeccao,
        props: true,
        meta: { feature: "PROSPECCAO" }
      },

      { path: "operacional/aulas-avulsas", name: "ListarAulasAvulsas", component: ListarAulasAvulsas },
      { path: "operacional/aulas-avulsas/novo", name: "CadastrarAulasAvulsas", component: FormularioAulaAvulsa },
      { path: "operacional/aulas-avulsas/:id", name: "EditarAulasAvulsas", component: FormularioAulaAvulsa, props: true },
      { path: '/operacional/aulas-avulsas/:id/detalhar', name: 'DetalharAulasAvulsas', component: DetalharAulaAvulsa, props: true },
      { path: "operacional/aulas-avulsas/imprimir-recibo/:id", name: "ImprimirReciboAulasAvulsas", component: ImprimirReciboAulasAvulsas },

      { path: "operacional/matriculas", name: "ListarMatriculas", component: ListarMatriculas },
      { path: "operacional/matriculas/novo", name: "CadastrarMatriculas", component: FormularioMatricula },
      { path: "operacional/matriculas/:id", name: "EditarMatriculas", component: FormularioMatricula, props: true },
      { path: '/operacional/matriculas/:id/detalhar', name: 'DetalharMatriculas', component: DetalharMatricula, props: true },
      {
        path: '/operacional/matriculas/:id/recibo',
        name: 'ImprimirReciboMatricula',
        component: ImprimirReciboMatricula,
        props: route => ({
          id: route.params.id,
          contrato: route.query.contrato || null
        })
      },

      { path: "modals", name: "RenovarMatricula", component: ModalRenovarMatricula },

      {
        path: "operacional/posvendas",
        name: "ListarPosvendas",
        component: ListarPosvendas,
        meta: { feature: "POSVENDAS" }
      },
      {
        path: '/operacional/posvendas/:id/detalhar',
        name: 'DetalharPosvendas',
        component: DetalharPosvenda,
        props: true,
        meta: { feature: "POSVENDAS" }
      },

      { path: "operacional/aulas-reposicao", name: "ListarAulasReposicao", component: ListarAulasReposicao },
      { path: "operacional/aulas-reposicao/novo", name: "CadastrarAulasReposicao", component: FormularioAulaReposicao },
      { path: "operacional/aulas-reposicao/:id", name: "EditarAulasReposicao", component: FormularioAulaReposicao, props: true },
      { path: '/operacional/aulas-reposicao/:id/detalhar', name: 'DetalharAulasReposicao', component: DetalharAulaReposicao, props: true },

      { path: "operacional/turmas-instrutor", name: "ListarTurmasInstrutor", component: ListarTurmasInstrutor },
      // { path: "operacional/turmas-instrutor/novo", name: "CadastrarTurmasInstrutor", component: FormularioTurmaInstrutor },
      // { path: "operacional/turmas-instrutor/:id", name: "EditarTurmasInstrutor", component: FormularioTurmaInstrutor, props: true },
      { path: '/operacional/turmas-instrutor/:id/detalhar', name: 'DetalharTurmasInstrutor', component: DetalharTurmaInstrutor, props: true },

      { path: "operacional/avaliacoes-desempenho", name: "ListarAvaliacoesDesempenho", component: ListarAvaliacoesDesempenho },
      // { path: "operacional/avaliacoes-desempenho/novo", name: "CadastrarAvaliacoesDesempenho", component: FormularioAvaliacaoDesempenho },
      // { path: "operacional/avaliacoes-desempenho/:id", name: "EditarAvaliacoesDesempenho", component: FormularioAvaliacaoDesempenho, props: true },
      // { path: "operacional/avaliacoes-desempenho/:id/detalhar", name: "DetalharAvaliacoesDesempenho", component: DetalharAvaliacaoDesempenho, props: true },

      { path: "operacional/supervisoes", name: "ListarSupervisoes", component: ListarSupervisoes },
      { path: "operacional/protocolos-queda", name: "ListarProtocolosQueda", component: ListarProtocolosQueda },

      { path: "operacional/emarketing-respativos", name: "ListarEmarketingRespativos", component: ListarEmarketingRespativos },
      { path: "operacional/emarketing-respinativos", name: "ListarEmarketingRespinativos", component: ListarEmarketingRespinativos },



      // Rotas de Loja

      { path: "loja/vendas", name: "ListarVendas", component: ListarVendas, meta: { feature: "LOJA" } },
      { path: "loja/vendas/novo", name: "CadastrarVendas", component: FormularioVenda, meta: { feature: "LOJA" } },
      { path: "loja/vendas/:id", name: "EditarVendas", component: FormularioVenda, props: true, meta: { feature: "LOJA" } },
      { path: '/loja/vendas/:id/detalhar', name: 'DetalharVendas', component: DetalharVenda, props: true, meta: { feature: "LOJA" } },
      { path: '/loja/vendas/:id/recibo', name: 'ReciboVenda', component: ReciboVenda, props: true, meta: { feature: "LOJA" } },

      { path: "/loja/entradas", name: "ListarEntradas", component: ListarEntradas, meta: { feature: "LOJA" } },
      { path: "/loja/entradas/novo", name: "CadastrarEntradas", component: FormularioEntrada, meta: { feature: "LOJA" } },
      { path: "/loja/entradas/:id", name: "EditarEntradas", component: FormularioEntrada, props: true, meta: { feature: "LOJA" } },
      { path: "/loja/entradas/:id/detalhar", name: "DetalharEntradas", component: DetalharEntrada, props: true, meta: { feature: "LOJA" } },



      // Rotas de Financeiro

      { path: "financeiro/valores", name: "ListarValores", component: ListarValores },
      { path: "financeiro/valores/novo", name: "CadastrarValores", component: FormularioValor },
      { path: "financeiro/valores/:id", name: "EditarValores", component: FormularioValor, props: true },
      { path: '/financeiro/valores/:id/detalhar', name: 'DetalharValores', component: DetalharValor, props: true },

      { path: "financeiro/planos-contas", name: "ListarPlanosContas", component: ListarPlanosContas },
      { path: "financeiro/planos-contas/novo", name: "CadastrarPlanosContas", component: FormularioPlanoConta },
      { path: "financeiro/planos-contas/:id", name: "EditarPlanosContas", component: FormularioPlanoConta, props: true },
      { path: '/financeiro/planos-contas/:id/detalhar', name: 'DetalharPlanosContas', component: DetalharPlanoConta, props: true },

      { path: "financeiro/subcontas", name: "ListarSubcontas", component: ListarSubcontas },
      { path: "financeiro/subcontas/novo", name: "CadastrarSubcontas", component: FormularioSubconta },
      { path: "financeiro/subcontas/:id", name: "EditarSubcontas", component: FormularioSubconta, props: true },
      { path: '/financeiro/subcontas/:id/detalhar', name: 'DetalharSubcontas', component: DetalharSubconta, props: true },

      { path: "financeiro/parametros/operadores", name: "ListarOperadoresPagamentos", component: ListarOperadoresPagamentos },
      { path: "financeiro/parametros/operadores/novo", name: "CadastrarOperadoresPagamentos", component: FormularioOperadorPagamento },
      { path: "financeiro/parametros/operadores/:id", name: "EditarOperadoresPagamentos", component: FormularioOperadorPagamento, props: true },
      { path: '/financeiro/parametros/operadores/:id/detalhar', name: 'DetalharOperadoresPagamentos', component: DetalharOperadorPagamento, props: true },

      { path: "financeiro/parametros/meios", name: "ListarMeiosPagamentos", component: ListarMeiosPagamentos },
      { path: "financeiro/parametros/meios/novo", name: "CadastrarMeiosPagamentos", component: FormularioMeioPagamento },
      { path: "financeiro/parametros/meios/:id", name: "EditarMeiosPagamentos", component: FormularioMeioPagamento, props: true },
      { path: '/financeiro/parametros/meios/:id/detalhar', name: 'DetalharMeiosPagamentos', component: DetalharMeioPagamento, props: true },

      { path: "financeiro/parametros/formas", name: "ListarFormasPagamentos", component: ListarFormasPagamentos },
      { path: "financeiro/parametros/formas/novo", name: "CadastrarFormasPagamentos", component: FormularioFormaPagamento },
      { path: "financeiro/parametros/formas/:id", name: "EditarFormasPagamentos", component: FormularioFormaPagamento, props: true },
      { path: '/financeiro/parametros/formas/:id/detalhar', name: 'DetalharFormasPagamentos', component: DetalharFormaPagamento, props: true },

      { path: "financeiro/parametros/bandeiras", name: "ListarBandeirasPagamentos", component: ListarBandeirasPagamentos },
      { path: "financeiro/parametros/bandeiras/novo", name: "CadastrarBandeirasPagamentos", component: FormularioBandeiraPagamento },
      { path: "financeiro/parametros/bandeiras/:id", name: "EditarBandeirasPagamentos", component: FormularioBandeiraPagamento, props: true },
      { path: '/financeiro/parametros/bandeiras/:id/detalhar', name: 'DetalharBandeirasPagamentos', component: DetalharBandeiraPagamento, props: true },

      { path: "financeiro/parametros/tipos", name: "ListarTiposPagamentos", component: ListarTiposPagamentos },
      { path: "financeiro/parametros/tipos/novo", name: "CadastrarTiposPagamentos", component: FormularioTipoPagamento },
      { path: "financeiro/parametros/tipos/:id", name: "EditarTiposPagamentos", component: FormularioTipoPagamento, props: true },
      { path: '/financeiro/parametros/tipos/:id/detalhar', name: 'DetalharTiposPagamentos', component: DetalharTipoPagamento, props: true },

      { path: "financeiro/parametros/taxas", name: "ListarTaxasPagamentos", component: ListarTaxasPagamentos },
      { path: "financeiro/parametros/taxas/novo", name: "CadastrarTaxasPagamentos", component: FormularioTaxaPagamento },
      { path: "financeiro/parametros/taxas/:id", name: "EditarTaxasPagamentos", component: FormularioTaxaPagamento, props: true },
      { path: "/financeiro/parametros/taxas/:id/detalhar", name: "DetalharTaxasPagamentos", component: DetalharTaxaPagamento, props: true },

      { path: "financeiro/contas-financeiras", name: "ListarContasFinanceiras", component: ListarContasFinanceiras },
      { path: "financeiro/contas-financeiras/novo", name: "CadastrarContasFinanceiras", component: FormularioContaFinanceira },
      { path: "financeiro/contas-financeiras/:id", name: "EditarContasFinanceiras", component: FormularioContaFinanceira, props: true },
      { path: '/financeiro/contas-financeiras/:id/detalhar', name: 'DetalharContasFinanceiras', component: DetalharContaFinanceira, props: true },

      { path: "financeiro/registros-financeiros", name: "ListarRegistrosFinanceiros", component: ListarRegistrosFinanceiros },
      { path: "financeiro/registros-financeiros/novo", name: "CadastrarRegistrosFinanceiros", component: FormularioRegistroFinanceiro },
      { path: "financeiro/registros-financeiros/:id", name: "EditarRegistrosFinanceiros", component: FormularioRegistroFinanceiro, props: true },
      { path: '/financeiro/registros-financeiros/:id/detalhar', name: 'DetalharRegistrosFinanceiros', component: DetalharRegistroFinanceiro, props: true },

      { path: "financeiro/receitas-planos", name: "ListarReceitasPlanos", component: ListarReceitasPlanos },
      // { path: "financeiro/receitas-planos/novo", name: "CadastrarReceitaPlano", component: FormularioReceitaPlano },
      // { path: "financeiro/receitas-planos/:id", name: "EditarReceitaPlano", component: FormularioReceitaPlano, props: true },
      { path: "/financeiro/receitas-planos/:id/detalhar", name: "DetalharReceitaPlano", component: DetalharReceitaPlano, props: true },

      { path: "/financeiro/receitas-gerais", name: "ListarReceitasGerais", component: ListarReceitasGerais, },
      { path: "/financeiro/receitas-gerais/novo", name: "CadastrarReceitaGeral", component: FormularioReceitaGeral, },
      { path: "/financeiro/receitas-gerais/:id", name: "EditarReceitaGeral", component: FormularioReceitaGeral, props: true, },
      // Compatibilidade com links de detalhe emitidos pela listagem anterior.
      { path: "/financeiro/receitas-gerais/:id/detalhar", name: "DetalharReceitaGeral", alias: "/financeiro/receitas/detalhar/:id", component: DetalharReceitaGeral, props: true, },

      { path: "/financeiro/despesas", name: "ListarDespesas", component: ListarDespesas, },
      { path: "/financeiro/despesas/novo", name: "CadastrarDespesa", component: FormularioDespesa, },
      { path: "/financeiro/despesas/:id", name: "EditarDespesa", component: FormularioDespesa, props: true, },
      { path: "/financeiro/despesas/:id/detalhar", name: "DetalharDespesa", component: DetalharDespesa, props: true, },

      { path: "financeiro/transferencias-contas", name: "ListarTransferenciasContas", component: ListarTransferenciasContas },
      { path: "financeiro/transferencias-contas/novo", name: "CadastrarTransferenciaConta", component: FormularioTransferenciaConta },
      { path: "financeiro/transferencias-contas/:id", name: "EditarTransferenciaConta", component: FormularioTransferenciaConta, props: true },
      { path: '/financeiro/transferencias-contas/:id/detalhar', name: 'DetalharTransferenciaConta', component: DetalharTransferenciaConta, props: true },

      { path: "/financeiro/conciliacao-bancaria", name: "ConciliacaoBancaria", component: ConciliacaoBancariaPage },

      { path: "financeiro/cobrancas", name: "ListarCobrancas", component: CobrancasEBoletos },
      { path: "financeiro/cobrancas/configuracoes", name: "ListarConfiguracoesCobrancas", component: ListarConfiguracoesCobrancas },
      { path: "financeiro/cobrancas/configuracoes/novo", name: "CadastrarConfiguracaoCobranca", component: FormularioConfiguracaoCobranca },
      { path: "financeiro/cobrancas/configuracoes/:id", name: "EditarConfiguracaoCobranca", component: FormularioConfiguracaoCobranca, props: true },
      { path: "financeiro/cobrancas/politicas", name: "ListarPoliticasCobrancas", component: ListarPoliticasCobrancas },
      { path: "financeiro/cobrancas/politicas/novo", name: "NovaPoliticaCobranca", component: FormularioPoliticaCobranca },
      { path: "financeiro/cobrancas/politicas/:id/detalhar", name: "DetalharPoliticaCobranca", component: DetalharPoliticaCobranca, props: true },
      { path: "financeiro/cobrancas/politicas/:id", name: "EditarPoliticaCobranca", component: FormularioPoliticaCobranca, props: true },
      { path: "financeiro/cobrancas/:id/detalhar", name: "DetalharCobranca", component: DetalharCobranca, props: true },

// Rotas de Configurações

      // Rotas de Perfis de Usuários
      { path: "configuracoes/perfis-de-usuarios", name: "ListarPerfisUsuarios", component: ListarPerfisUsuarios },
      { path: "configuracoes/perfis-de-usuarios/novo", name: "CadastrarPerfilUsuario", component: FormularioPerfilUsuario },
      { path: "configuracoes/perfis-de-usuarios/:id", name: "EditarPerfilUsuario", component: FormularioPerfilUsuario, props: true },
      { path: '/configuracoes/perfis-de-usuarios/:id/detalhar', name: 'DetalharPerfilUsuario', component: DetalharPerfilUsuario, props: true },

      // Rotas de Usuários
      { path: "configuracoes/usuarios", name: "ListarUsuarios", component: ListarUsuarios },
      { path: "configuracoes/usuarios/novo", name: "CadastrarUsuario", component: FormularioUsuario },
      { path: "configuracoes/usuarios/:id", name: "EditarUsuario", component: FormularioUsuario, props: true },
      { path: '/configuracoes/usuarios/:id/detalhar', name: 'DetalharUsuario', component: DetalharUsuario, props: true },
      { path: "/configuracoes/usuarios/selecionar-pessoa-fisica", name: "SelecionarPessoaFisica", component: SelecionarPessoaFisica },

      // Rotas de Documentos
      { path: "configuracoes/documentos", name: "ListarDocumentos", component: ListarDocumentos },
      { path: "configuracoes/documentos/novo", name: "CadastrarDocumento", component: FormularioDocumento },
      { path: "configuracoes/documentos/:id", name: "EditarDocumento", component: FormularioDocumento, props: true },
      { path: '/configuracoes/documentos/:id/detalhar', name: 'DetalharDocumento', component: DetalharDocumento, props: true },

      { path: "configuracoes/parametros-avaliacoes/categorias", name: "ListarCategoriasAvaliacoes", component: ListarCategoriasAvaliacoes },
      { path: "configuracoes/parametros-avaliacoes/categorias/novo", name: "CadastrarCategoriasAvaliacoes", component: FormularioCategoriaAvaliacao },
      { path: "configuracoes/parametros-avaliacoes/categorias/:id", name: "EditarCategoriasAvaliacoes", component: FormularioCategoriaAvaliacao, props: true },
      { path: '/configuracoes/parametros-avaliacoes/categorias/:id/detalhar', name: 'DetalharCategoriasAvaliacoes', component: DetalharCategoriaAvaliacao, props: true },

      { path: "configuracoes/parametros-avaliacoes/blocos", name: "ListarBlocosAvaliacoes", component: ListarBlocosAvaliacoes },
      { path: "configuracoes/parametros-avaliacoes/blocos/novo", name: "CadastrarBlocosAvaliacoes", component: FormularioBlocoAvaliacao },
      { path: "configuracoes/parametros-avaliacoes/blocos/:id", name: "EditarBlocosAvaliacoes", component: FormularioBlocoAvaliacao, props: true },
      { path: '/configuracoes/parametros-avaliacoes/blocos/:id/detalhar', name: 'DetalharBlocosAvaliacoes', component: DetalharBlocoAvaliacao, props: true },

      { path: "configuracoes/parametros-avaliacoes/questoes", name: "ListarQuestoesAvaliacoes", component: ListarQuestoesAvaliacoes },
      { path: "configuracoes/parametros-avaliacoes/questoes/novo", name: "CadastrarQuestoesAvaliacoes", component: FormularioQuestaoAvaliacao },
      { path: "configuracoes/parametros-avaliacoes/questoes/:id", name: "EditarQuestoesAvaliacoes", component: FormularioQuestaoAvaliacao, props: true },
      { path: "/configuracoes/parametros-avaliacoes/questoes/:id/detalhar", name: "DetalharQuestoesAvaliacoes", component: DetalharQuestaoAvaliacao, props: true },

      { path: "configuracoes/parametros-avaliacoes/opcoes", name: "ListarOpcoesAvaliacoes", component: ListarOpcoesAvaliacoes },
      { path: "configuracoes/parametros-avaliacoes/opcoes/novo", name: "CadastrarOpcoesAvaliacoes", component: FormularioOpcaoAvaliacao },
      { path: "configuracoes/parametros-avaliacoes/opcoes/:id", name: "EditarOpcoesAvaliacoes", component: FormularioOpcaoAvaliacao, props: true },
      { path: "/configuracoes/parametros-avaliacoes/opcoes/:id/detalhar", name: "DetalharOpcoesAvaliacoes", component: DetalharOpcaoAvaliacao, props: true },

      { path: "configuracoes/formularios-avaliacoes", name: "ListarFormulariosAvaliacoes", component: ListarFormulariosAvaliacoes },
      { path: "configuracoes/formularios-avaliacoes/novo", name: "CadastrarFormulariosAvaliacoes", component: FormularioFormularioAvaliacao },
      { path: "configuracoes/formularios-avaliacoes/:id", name: "EditarFormulariosAvaliacoes", component: FormularioFormularioAvaliacao, props: true },
      { path: "/configuracoes/formularios-avaliacoes/:id/detalhar", name: "DetalharFormulariosAvaliacoes", component: DetalharFormularioAvaliacao, props: true },

      // Rotas de Recessos
      { path: "configuracoes/recessos", name: "ListarRecessos", component: ListarRecessos },
      { path: "configuracoes/recessos/novo", name: "CadastrarRecesso", component: FormularioRecesso },
      { path: "configuracoes/recessos/:id", name: "EditarRecesso", component: FormularioRecesso, props: true },
      { path: '/configuracoes/recessos/:id/detalhar', name: 'DetalharRecesso', component: DetalharRecesso, props: true },



      // Rotas de Ajuda

      // Rotas de Materiais
      { path: "ajuda/materiais", name: "ListarMateriais", component: ListarMateriais },
      { path: "ajuda/materiais/novo", name: "CadastrarMaterial", component: FormularioMaterial },
      { path: "ajuda/materiais/:id", name: "EditarMaterial", component: FormularioMaterial, props: true },
      // { path: '/ajuda/materiais/:id/detalhar', name: 'DetalharMaterial', component: DetalharMaterial, props: true },

      // Rotas de Videoaulas
      { path: "ajuda/videoaulas", name: "ListarVideoaulas", component: ListarVideoaulas },
      { path: "ajuda/videoaulas/novo", name: "CadastrarVideoaula", component: FormularioVideoaula },
      { path: "ajuda/videoaulas/:id", name: "EditarVideoaula", component: FormularioVideoaula, props: true },
      // { path: '/ajuda/videoaulas/:id/detalhar', name: 'DetalharVideoaula', component: DetalharVideoaula, props: true },

      // Rotas de Quiz
      { path: "ajuda/quiz", name: "ExibirQuiz", component: ExibirQuiz },

      // Rotas de Jogos
      { path: "ajuda/jogos", name: "ExibirCavalinho", component: ExibirCavalinho },

      // Rotas de Montador de Pista
      { path: "ajuda/montador", name: "MontadorDePista", component: ExibirMontador },

    ],
  },
  { path: "/:pathMatch(.*)*", redirect: "/login" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
